<a [href]="monHref" [ngClass]="{ 'reverse': monReversePosition }" [target]="monTarget">
    <mon-icon [monIconDirect]="monIconDirect"></mon-icon>
    <span>{{ monLinkText }}</span>
</a>
